import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allPlayersRefresh } from "../Redux/allPlayersSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { generalPostFunction, hasAccess } from "../Globals/globalFunctions";
import { userLevelArray } from "../Globals/globalMetaData";
import { toast } from "react-toastify";
import { SvgIcon } from "../Components/SvgIcons";

function AllAccounts({ pageName, sendMessage }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const setAllPlayers = useSelector((state) => state.allPlayers.setAllPlayers);
	const [filteredAccounts, setFilteredAccounts] = useState([]);
	const account = JSON.parse(localStorage.getItem("account"));
	const onlineUsers = useSelector((state) => state.allPlayers.onlineUsers);
	const [deleteItem, setDeleteItem] = useState();

	useEffect(() => {
		if (allPlayersRefresh) {
			dispatch(allPlayersRefresh((prev) => prev + 1));
		}
	}, [allPlayersRefresh]);

	useEffect(() => {
		if (setAllPlayers && setAllPlayers.length > 0) {
			handleFilter();
		}
	}, [setAllPlayers, location.pathname]);

	const handleFilter = () => {
		let filterLevel;
		switch (location.pathname) {
			case "/all-super-stokez":
				filterLevel = 1;
				break;
			case "/all-stokez":
				filterLevel = 2;
				break;
			case "/all-master":
				filterLevel = 3;
				break;
			case "/all-agents":
				filterLevel = 4;
				break;
			case "/all-users":
				filterLevel = 5;
				break;
			default:
				filterLevel = null;
				break;
		}

		if (filterLevel !== null) {
			const filteredData = setAllPlayers.filter((item) => item.level == filterLevel);
			setFilteredAccounts(filteredData);
		} else {
			setFilteredAccounts(setAllPlayers);
		}
	};

	const forceLogout = (username) => {
		sendMessage({
			action: "forceLogout",
			data: [
				{
					username: username,
				},
			],
		});
	};

	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>
										{pageName}{" "}
										<button className="clearButton" onClick={() => dispatch(allPlayersRefresh((prev) => prev + 1))}>
											<SvgIcon name="refresh" />
										</button>
									</h4>
								</div>
								<div className="buttonGroup">
									<button className="panelButton gray" onClick={() => navigate(-1)}>
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
									{hasAccess(account, 4) && (
										<button
											type="button"
											className="panelButton"
											onClick={() =>
												navigate("/create-account", {
													state: location.pathname,
												})
											}
										>
											<span className="text">Add</span>
											<span className="icon">
												<SvgIcon name="plus" />
											</span>
										</button>
									)}
								</div>
							</div>
						</div>
						<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
							<div className="tableContainer">
								<table>
									<thead>
										<tr>
											<th>#</th>
											<th>Username</th>
											<th>Password</th>
											<th>Balance</th>
											<th>Level</th>
											<th>Status</th>
											<th>Activity</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										{filteredAccounts && filteredAccounts.length > 0 ? (
											filteredAccounts.map((item, index) => {
												return (
													<tr key={item.username || index}>
														<td>{index + 1}</td>
														<td>{item.username}</td>
														<td>{item.password}</td>
														<td>{parseInt(item.user_balance) || 0}</td>
														<td>{userLevelArray?.find((user) => user?.level == item?.level)?.name || "N/A"}</td>
														<td>{item.registerstate == 1 ? "Enable" : "Disable"}</td>
														<td>
															<div className="d-flex align-items-center">
																<span className={`liveStatus ${onlineUsers?.map((u) => u.toLowerCase()).includes(item.username.toLowerCase()) ? "online" : ""}`}></span>
																{onlineUsers?.map((u) => u.toLowerCase()).includes(item.username.toLowerCase()) && (
																	<button className="tableButton delete ms-2 w-auto fw-bold" onClick={() => forceLogout(item.username)}>
																		LogOut
																	</button>
																)}
															</div>
														</td>
														<td>
															<div className="d-flex">
																<button className="tableButton edit me-2" onClick={() => navigate("/edit-account", { state: item })}>
																	<SvgIcon name="edit" />
																</button>
																{account.level == 0 || account.level == item.level - 1 ? (
																	<button
																		className="tableButton warning me-2"
																		onClick={() =>
																			navigate("/transfer-points", {
																				state: item,
																			})
																		}
																	>
																		<SvgIcon name="wallet" />
																	</button>
																) : (
																	""
																)}
																<button
																	className="tableButton delete me-2"
																	onClick={() =>
																		navigate("/turnover-report", {
																			state: item,
																		})
																	}
																>
																	<SvgIcon name="chart" />
																</button>
																<button className="tableButton delete" onClick={() => setDeleteItem(item)}>
																	<SvgIcon name="trash" />
																</button>
															</div>
														</td>
													</tr>
												);
											})
										) : (
											<tr>
												<td>No User Found!</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			{deleteItem && Object.entries(deleteItem).length > 0 ? (
				<DeleteUserPopup deleteItem={deleteItem} reset={() => dispatch(allPlayersRefresh((prev) => prev + 1))} setDeleteItem={setDeleteItem} />
			) : (
				""
			)}
		</>
	);
}

export default AllAccounts;

const DeleteUserPopup = ({ deleteItem, reset, setDeleteItem }) => {
	const deleteAccount = async () => {
		const payload = {
			username: deleteItem.username,
		};

		const response = await generalPostFunction("/removeuser", payload, "3040");

		if (response.message) {
			toast.success("Account deleted successfully!");
			setDeleteItem();
			reset();
		} else {
			toast.error("Account deletion failed");
		}
	};

	return (
		<>
			<div className="popup">
				<div className="container h-100">
					<div className="row h-100 justify-content-center align-items-center">
						<div className="content col-xl-4 col-md-5">
							<div className="col-12">
								<h4 className="textDactivate text-start ">Confirmation!</h4>
								<p className="text-start">Are you sure you want to delete this user?</p>
								<div className="d-flex justify-content-end  mt-4">
									<button className="panelNewButtons" onClick={() => setDeleteItem()}>
										<span className="text">Cancel</span>
									</button>
									<button className="panelNewButtons del" onClick={deleteAccount}>
										<span className="text me-2">Delete</span>
										<span className="icon">
											<SvgIcon name="check" />
										</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
